export const GET_PATIENT_PRESCRIPTIONS =
  'patientPrescription/getPatientPrescriptions'
export const ADD_PATIENT_PRESCRIPTION =
  'patientPrescription/addPatientPrescription'
export const DELETE_PATIENT_PRESCRIPTION =
  'patientPrescription/deletePatientPrescription'
export const SERVER_ERROR_PATIENT_PRESCRIPTION =
  'patientPrescription/errorPatientPrescription'
